var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "crud" }, [
    _c("form", [
      _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
        _c(
          "div",
          {
            staticClass: "row",
            staticStyle: { "padding-left": "15px !important" },
          },
          [
            _c("div", { staticClass: "col-sm-12" }, [
              _c(
                "table",
                {
                  staticClass: "table table-striped ajusteVer2",
                  attrs: { id: "t1" },
                },
                [
                  _c("tbody", [
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.$t("__.Crud.coleta.ver_vue_html.data"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("h4", [
                          _vm._v(_vm._s(_vm.formatData(_vm.model.data))),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("__.Crud.coleta.ver_vue_html.descricao")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("h4", [_vm._v(_vm._s(_vm.model.descricao))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("__.Crud.coleta.ver_vue_html.cliente")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("h4", [_vm._v(_vm._s(_vm.model.clienteNome))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.$t("__.Crud.coleta.ver_vue_html.status"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("h4", [_vm._v(_vm._s(_vm.model.statusDescricao))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("__.Crud.coleta.ver_vue_html.vendedor")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("h4", [_vm._v(_vm._s(_vm.model.vendedorNome))]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("__.Crud.coleta.ver_vue_html.localEntrega")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("h4", [
                          _vm._v(_vm._s(_vm.model.localEntregaDescricao)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("__.Crud.coleta.ver_vue_html.endereco")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("h4", [
                          _vm._v(_vm._s(_vm.model.enderecoEntregaCliente)),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }